import { DOCUMENT_ID } from 'api/config';
import { FC } from 'react';
import DocumentProvider from 'views/pages/clients/features/detail/workflow/features/document-builder/context/document.context';

const CustomProvider: FC<{}> = ({ children }) => <DocumentProvider initialDocument={{ id: DOCUMENT_ID }}>{children}</DocumentProvider>;

export default CustomProvider;
